
(function($) {

    var App = {


        has_more_reviews: true,
        has_imported_reviews: false,


        init: function(){

            var t = this;

            $("body.collection .sympthoms-boxes-new .section-anchor.open-badge").on("click", function(e){
                e.preventDefault();
                var elem = $(this);
                $("."+elem.attr("data-bage")).slideToggle();
                $(elem).toggleClass("opened");
            });
            


            t.events();
            t.initHamburgerMenu();
            t.initSlickGalleries(); 
            t.handleSubscription();
            t.toggleBwpBtn();

            $(document).on("dgtlz_cart_updated", function(e, cart){
                t.cartUpdated(e, cart);
            });



          if($("#rc_container").length) {
            
            // var rcListener = document.getElementById('rc_shipping_interval_unit_type');

            // var observer = new MutationObserver(function(mutations) {
            //   $("#rc_container").addClass("inited");
            //   $(".product-form--atc-button").attr("disabled", false);
            // });
            
            // observer.observe(rcListener, { 
            //   attributes: true, 
            //   attributeFilter: ['id'] 
            // });
            
          }else if($(".product-form--atc-button").length){
            $(".product-form--atc-button").attr("disabled", false);
          }

          
          $(document).scroll(function() {
            $(".live-search").removeClass("opened");
          });


          $(document).on("click", "#minicart .qty-widget .trigger-qty, body.cart .qty-widget .trigger-qty", function(e) {

                var qtyChanged = false;
                var elem = $(this);
                var item_id = elem.closest(".cart-item").attr("data-cartitem-id");
                var item_line = elem.closest(".cart-item").attr("data-cartitem-line");
                var qtyInput = elem.parent().parent().parent().parent().find($(".form-field--qty-input .form-field-input"));
                var qtyTextElem = elem.parent().parent().find($(".qty-num"));
                var currentQty = parseInt(qtyInput.val());
                var newQty = currentQty;

                if(elem.hasClass("increase")) {
                    newQty = currentQty + 1;
                    qtyChanged = true;
                }else{
                    if(currentQty > 1){
                        newQty = currentQty - 1;
                        qtyChanged = true;
                    }
                }

                qtyInput.val(parseInt(newQty));
                qtyTextElem.text(newQty);
                if(qtyChanged) {
                    t.minicartUpdateQty(newQty, item_id, item_line);
                }
                

                e.preventDefault();
                return false;
                
        });

        $(document).on("click", "#minicart .cart-item--remove-link", function(e){
            e.preventDefault();
            var elem = $(this);
            var qty = 0;
            var product_container = elem.closest(".cart-item");
            var item_id = product_container.attr("data-cartitem-id");
            var item_line = product_container.attr("data-cartitem-line");
            product_container.remove();
            t.minicartUpdateQty(qty, item_id,item_line);
        });



            $(".open-search").on("click", function(){
                $('#top_menu .icons-col .search-form').stop().slideToggle();
            });

            $("#menu-main-menu li.menu-item-has-children").on("mouseover", function(){
                var elem = $(this);
                var windowWidth = $(window).width();
                var menuOffset = $("#menu-main-menu").offset();
                var elemOffset = elem.offset();
                var menu_w = windowWidth - (menuOffset.left * 2);
                // var menu_w = $("#top_menu").outerWidth(); 
                if(elemOffset.left > (windowWidth / 2)) {
                    elem.addClass("to-the-left");
                }
                $("body").get(0).style.setProperty('--menu-w', menu_w +"px");
                $("body").addClass("sub-menu-opened");
                var subMenu = $(this).find(".sub-menu");
                subMenu.stop().slideDown(0,function(){
                    $(".menu-bg").css("height", $(this).outerHeight() + 50);
                });
            });

            $("#menu-main-menu li.menu-item-has-children").on("mouseout", function(){
                $("body").removeClass("sub-menu-opened");
                $(".menu-bg").css("height", 0);
            });

          
          
          
          $('body').click(function(evt){    
            if($(evt.target).hasClass("search-item") || $(evt.target).closest('.search-item').length || 
            $(evt.target).hasClass("cart-link") || $(evt.target).closest('.cart-link').length || 
            $(evt.target).hasClass("cart-item--remove-link") || $(evt.target).closest(".cart-item--remove-link").length ||
            ($(evt.target).closest('#minicart').length && !$(evt.target).hasClass("close-btn")) 
            ){
              return;
            }

            $(".live-search").removeClass("opened");
            t.hideMinicart();
            	
          });
          
          
          $(".details-accordion .title").on("click", function(){
          	$(this).parent().find(".content").stop().slideToggle();
            $(this).parent().toggleClass("opened");
          });
          
          
            if($("body").hasClass("product") ) {

                t.toggleOptionCopy();

                $(".product-form--atc .qty-widget .trigger-qty").on("click", function(e) {

                    var elem = $(this);
                    var qtyInput = $(".product-form--atc .form-field--qty-input .form-field-input");
                    var currentQty = parseInt(qtyInput.val());
                    var newQty = currentQty;

                    if(elem.hasClass("increase")) {
                        newQty = currentQty + 1;
                    }else{
                        if(currentQty > 1){ 
                            newQty = currentQty - 1;
                        }
                    }

                    qtyInput.val(parseInt(newQty));
                    $(".product-form--atc .qty-widget .qty-num").text(newQty);

                    e.preventDefault();
                    return false;
                });

                if($("#tp_reviews_wrapper").length) {
                  t.initProductReviews();	  
                }
                
                // t.initOneTimePopup();

                $(document).on("digi_added_to_cart", function(){
                    return window.location.href = "/cart";
                    

                    $(".atc-banner--container").removeClass("visible");
                    $("#minicart").addClass("loading");
                    //add to minicart
                    var tpl = "";
                    $.getJSON('/cart.js', function(cart) {
                        

                        $("#minicart .cart-subtotal .money").text(Shopify.formatMoney(cart.items_subtotal_price)); //update cart total

                        cart.items.forEach(function(item, index) {


                            if(item.selling_plan_allocation) {

                                
                                if($(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='true']`).length){
                                    $(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='true'] [data-cartitem-quantity]`).val(item.quantity);
                                    $(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='true'] [data-cartitem-quantity-text]`).text(item.quantity);
                                    t.mimicartToggleQtyDisplay(item);
                                }else{
                                    tpl += t.buildMinicartItem(item, index);
                                    $(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='true'] [data-cartitem-quantity]`).val(item.quantity);
                                    t.mimicartToggleQtyDisplay(item);
                                }

                            }else{
                                if($(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='false']`).length){
                                    //Item alreay in cart - increase qty & change totals.
                                    var item_total = Shopify.formatMoney(item.final_line_price);
                                    $(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='false'] [data-cartitem-quantity]`).val(item.quantity);
                                    $(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='false'] [data-cartitem-quantity-text]`).text(item.quantity);
                                    t.mimicartToggleQtyDisplay(item);
                                    
                                }else{
                                    //Item not in cart - add new item template
                                    tpl += t.buildMinicartItem(item);
                                    $(`#minicart .cart-item[data-cartitem-id='${item.id}'][data-is-selling-plan='false'] [data-cartitem-quantity]`).val(item.quantity);
                                    t.mimicartToggleQtyDisplay(item);
                                }

                            }
                            
                            
                            
                        });

                        if(tpl) {

                            $("#minicart .cart-items-col").prepend(tpl);

                            $("#minicart [data-quantity-input]").each(function(key, elem){
                                var realQty = $(elem).val();
                                $(elem).parent().parent().find(`[data-quantity-select]`).val(realQty);
                            });

                        }

                        $("#minicart").removeClass('empty');
                        $("#minicart .cart-items-col .minicart-title").remove();
                        $("#minicart .minicart-footer").show();
                        $("#minicart .minicart-empty-footer").hide();
                        $("#minicart  .minicart-title.main").show();
                        $("#minicart").removeClass("loading");
                        t.minicartUpdateLineNumbers();
                        t.showMinicart();
                        
                    });
                });
              	

            }
          
          	if($(".payment-opts").length){
            	t.setupPaymentOpts();	
            }
	
            if($("body").hasClass("cart")) {
                t.initModals();
            }
            

            if($("#floating_add_to_cart").length) {
                t.initFloatingATC();
            }

            if($("#floating_checkout_btn").length){
                t.initFloatingCheckout();
            }
          
            if($("form#customer_login").length){
				t.setLoginRedirUrl();
            }
          

            // $("#rc_radio_options .rc_radio__onetime").on("change", function () {
            // });
       
        },

        events: function(){


           $(document).on("click", ".gsc-results-close-btn", function(){
                $('#top_menu .icons-col .search-form').stop().slideUp();
            });

            $(".open-search-box").click(function(){
                var current = $(this);
                current.parent().find(".live-search").toggleClass("opened");
            });

            $(".mobile-menu-wrapper .menu-item-has-children .navmenu-link.navmenu-link-parent").click(function(e){
                e.preventDefault();
                var current = $(this);
                var elem = current.parent();
                var widget = elem.find('.sub-menu');
                
                if(widget.hasClass("active")){
                    widget.stop().slideUp().removeClass("active");
                    elem.removeClass("active");
                }else{
                    $(".sub-menu.active").stop().slideUp().removeClass("active");
                    widget.stop().slideDown().addClass("active");
                    $(".mobile-menu-wrapper .menu-item-has-children .navmenu-link.navmenu-link-parent.active").removeClass("active");
                    elem.addClass("active");
                }
            });

        },


        cartUpdated: function(e, cart)
        {
            var t = this;
            var has_subscription_product = false;
            var is_free_shipping = false;
            var items = cart.items;
            
            var total = cart.total_price / 100;

            if(items && items.length) {


                $.each(items, function (i, item) {

                    if(item.selling_plan_allocation){
                        has_subscription_product = true;
                        is_free_shipping = true;
                    }

                });
    
    
                if(!has_subscription_product) {

                    if(total >= 69) {
                        is_free_shipping = true;
                    }
                }

                var tpl = '';
                if(is_free_shipping) {
                    tpl = `
                        <div class="fs-indicator">
                            <div class="txt color1 bold">Free shipping all the time!</div>
                        </div>
                        <div class="small-note">*USA only</div>
                    `;
                }else{
                    var diff = (69 - total);
                    var diff_for_shopify = 6900 - cart.total_price;                    
                    var diff_percentages = 100 - ((diff / 69) * 100).toFixed(2);
                    var money = Shopify.formatMoney(diff_for_shopify);
                    tpl = `
                    <div class="fs-indicator">
                        <div class="txt color1 bold">Free shipping all the time!</div>
                    </div>
                    <div class="small-note">*USA only</div>
                `;
                }

                $(".fs-indicator-wrap").html(tpl);

            }else{
                $(".fs-indicator-wrap").html("");
            }

            var items_count = cart.item_count;
            if(items_count > 0) {

                var count_txt = items_count > 1 ? 'items' : 'item';
                
                var cart_total = Shopify.formatMoney(cart.items_subtotal_price);

                if($(".minicart-items .cartitems .cart-total").length) {

                    $("#minicart .inner .cart-subtotal .count").text(`(${items_count} ${count_txt})`);
                    $("#minicart .cart-subtotal .money").text(Shopify.formatMoney(cart.items_subtotal_price)); //update cart total

                }else{

                    var totalTpl = `
                        <div class="cart-total col-12">
                            <div class="cart-subtotal">
                                <span>Subtotal <em class="count">(${items_count} ${count_txt})</em></span>
                                <span class="money" data-cart-total="">${cart_total}</span>
                            </div>
                        </div>
                    `;
                    $(".minicart-items .cartitems").append(totalTpl);
                    
                }

                

                if($("body").hasClass("cart")) {
                    $(".cartitems .cart-total .cart-subtotal .count").text(`(${items_count} ${count_txt})`);
                    $(".cartitems .cart-total .cart-subtotal .money").text(cart_total);
                }

            }
            
            t.minicartUpdateLineNumbers();

        },


      
      setLoginRedirUrl: function()
      {
      	 var redir_elem = $("input[name='return_url']");
          if(redir_elem.length && redir_elem.val().indexOf("checkout.rechargeapps.com") > -1){
              sessionStorage.setItem('redirectURI', redir_elem.val());
          }
      },
      
      
      
      setupPaymentOpts: function(){
      	var t = this;
        var imageElement = $(".payment-opts .opts-img");
        var url = "https://shop.womenshealthnetwork.com/cdn/shop/t/175/assets/payment-methods-non-ios.png?v=151895830162742346461759649093";
        var isIosOrSafari = t.isIos();
        if(isIosOrSafari) {
            url = "https://shop.womenshealthnetwork.com/cdn/shop/t/175/assets/payment-methods.png?v=143825520764792869921758783035";
        }

        imageElement.on("load", function(){
            imageElement.addClass("active");
        });


        $(".payment-opts .opts-img").attr("src",url);
      },
      
      
      isIos : function(){
        var isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      	return isIOSDevice || isSafari;
      },
      
      
       initOneTimePopup: function(){
            $(".rc_radio__onetime").on('change',function(){
                if($(this).is(":checked")) {
                   $("#subscribe_popup").fadeIn();
                   $("#shopify-section-static-header-new").css("z-index", 10);
                }
            });
         
         	$(document).on("click", "#subscribe_popup .try-btn", function(){
                $("#subscribe_popup").fadeOut();
                $("#shopify-section-static-header-new").css("z-index", 700);
                $(".rc_radio__autodeliver").prop("checked", true).trigger("change").trigger("click");
            });

            $(".cancel-btn, .close-btn, #subscribe_popup .overlay").on("click", function(e){
                e.preventDefault();
                $("#shopify-section-static-header-new").css("z-index", 700);
                $("#subscribe_popup").fadeOut();
            });
        },


        toggleOptionCopy: function(){
            
            $(".rc-radio__input").on("change", function(){

                var elem = $(this);
                var isAutodelivery = elem.hasClass("rc_widget__option__input--subsave");
                $("#rc_container .notes.active").removeClass("active");
                elem.parent().parent().find($(".notes")).addClass("active");
                $(".rc_block__type--active").removeClass('rc_block__type--active');
                elem.closest('.rc_block__type').addClass('rc_block__type--active');

                if(isAutodelivery) {
                    $(".product-form--atc .qty-widget").hide();
                    $(".product-form--atc .qty-widget .qty-num").text(1);
                    $(".product-form--atc .form-field--qty-input .form-field-input").val(1);
                }else{
                    $(".product-form--atc .qty-widget").show();
                }

            });

        },



      initProductReviews : function()
      {

          if($("#no_reviews_warp").length) {
            return;
          }
        
          var me = this;
          var was_in = false;


         if(window.location.hash == "#product_reviews"){
            was_in = true;
            me.getProductReviews();
          }


          $(".details-accordion .item.reviews .title").on("click", function(){
              me.getProductReviews();
          });

          $(document).on("click", '.load-more-reviews', function(e){
              e.preventDefault();
              if(!$(this).hasClass("disabled")){
                  $(this).addClass("disabled");
                  var next_url = $(this).attr("data-href");
                  if(me.has_more_reviews){
                    me.getProductReviews(next_url);    
                  }else{
                    me.getImportedProductReviews(next_url);  
                  }
                  
              }
          });

          me.requestProductReviews("https://api.trustpilot.com/v1/product-reviews/business-units/" + window.tp_business_id + "/imported-reviews?sku=" + window.product_skus, function(res) {
              if(!res.error && res.productReviews && res.productReviews.length){
                  me.has_imported_reviews = true;
              }else{
                  me.has_imported_reviews = false;
              }

              $(document).on("scroll", function(){
                if(!was_in) {
                    var scroll_to = $(".details-wrapper").offset().top;
                    var st = $(document).scrollTop();
                    if(st > scroll_to) {
                        was_in = true;
                        me.getProductReviews();
                    }
                }
              });
            
          });
  
          
  
      },
  
  
      getProductReviews: function(next_url)
      {
          var me = this;
          var skus = window.product_skus;
          var bid = window.tp_business_id;
          var reviews_url = next_url ? next_url : "https://api.trustpilot.com/v1/product-reviews/business-units/" + bid + "/reviews?sku=" + skus;
          me.requestProductReviews(reviews_url, function(res) {
              if(res.error || !res.productReviews || !res.productReviews.length){
                  me.getImportedProductReviews();
              }else{
                  me.appendProductReviews(res);
              }
          });
      },
  
  
  
      getImportedProductReviews: function(next_url)
      {
          var me = this;
          var skus = window.product_skus;
          var bid = window.tp_business_id;
          var imported_url = next_url ? next_url : "https://api.trustpilot.com/v1/product-reviews/business-units/" + bid + "/imported-reviews?sku=" + skus;
          me.requestProductReviews(imported_url, function(res) {
              if(res.error || !res.productReviews || !res.productReviews.length){
                  //No reviews
              }else{
                  me.appendImportedProductReviews(res);
              }
          });
      },
  
  
      requestProductReviews: function(url, cb)
      {
          var me = this;
          var api_key = "Uc7BHdJgTjyxjNrRX3HhBzb5L3T1nmYi";
          $.ajax({
              type: "GET",
              url : url + "&apikey=" + api_key,
              success: function(res){
                  cb(res);
              },
              error : function(err){
                  cb({"error" : err});
              }
          });
      },
  
  
  
      appendProductReviews: function(res)
      {
          var me = this;
          var tpl = '';
          var next_page_url = null;
  
          if(res.links && res.links.length && res.links[0].rel === "next-page"){
            me.has_more_reviews = true;
            next_page_url = res.links[0].href;
          }else if(res.links && res.links.length && res.links[0].rel === "prev-page" && me.has_imported_reviews){
            me.has_more_reviews = false;
            next_page_url = "https://api.trustpilot.com/v1/product-reviews/business-units/" + window.tp_business_id + "/imported-reviews?sku=" + window.product_skus;
          }else if(me.has_imported_reviews) {
            me.has_more_reviews = false;
            next_page_url = "https://api.trustpilot.com/v1/product-reviews/business-units/" + window.tp_business_id + "/imported-reviews?sku=" + window.product_skus;
          }
  
          var product_reviews = res.productReviews;
          var reviews_id_featured_list = window.reviews_id_featured_list
          
          product_reviews.forEach(function(item, index){
            if(!reviews_id_featured_list.includes(item.id)){
              tpl += me.singleReviewTemplate(item.stars, item.consumer.displayName, item.createdAt,item.content, true, item.id);
            }
          });
        
          if(next_page_url) {
              tpl += `<div class="load-more-reviews-wrap text-center">
                        <a data-href="${next_page_url}" class="load-more-reviews link">Load more reviews</a>
                      </div>`;
          }
          
          $("#tp_reviews_wrapper .loader, #tp_reviews_wrapper .load-more-reviews-wrap").remove();
          $("#tp_reviews_wrapper").append(tpl);
      },
  
  
  
      appendImportedProductReviews: function(res)
      {
          var me = this;
          var tpl = '';
          var next_page_url = null;
  
          if(res.links && res.links.length && res.links[0].rel === "next-page"){
              next_page_url = res.links[0].href;
          }
  
          var product_reviews = res.productReviews;
          
          product_reviews.forEach(function(item, index){
              tpl += me.singleReviewTemplate(item.stars, item.consumer.name, item.createdAt,item.content);
          });
          if(next_page_url) {
              tpl += `<div class="load-more-reviews-wrap text-center">
                      <a data-href="${next_page_url}" class="load-more-reviews link">Load more reviews</a>
                      </div>`;
          }
          
          $("#tp_reviews_wrapper .loader, #tp_reviews_wrapper .load-more-reviews-wrap").remove();
          $("#tp_reviews_wrapper").append(tpl);
      },
  
  
  
      singleReviewTemplate: function(stars, name, createdAt, content, verified, id)
      {
          var tpl = '';
          var review_date = new Date(createdAt);
          var review_month = review_date.toLocaleString('en', { month: 'long' });
          var stars_tpl = '';
          var review_id = ''
          if(id){review_id = " ["+ id + "]";}
          for(var i=1; i <= 5; i++) {
              if(i <= stars){
                  stars_tpl += '<div class="star goldstardiv">&#x2605;</div>';
              }else{
                  stars_tpl += '<div class="star">&#x2605;</div>';
              }
          }
  
          tpl += `<div class="review-wrapper py-5 px-4">
                      <div class="review-title color2 h3">${name}, <span>${review_month} ${review_date.getDate()}</span></div>
                      <div class="rating-stars my-3">${stars_tpl}</div>
                      <div class="review-content color1 p">${content}</div>`;

          if(verified) {
            tpl += `<p class="verified real color1 mt-3 mb-0"><span></span>Verified, collected by Women's Health Network</p></div>`;  
            //display review ID: tpl += `<p class="verified real color1 mt-3 mb-0"><span title=${id}></span>Verified, collected by Women's Health Network</p></div>`;  
          }else{
            tpl += `<p class="verified color1 mt-3 mb-0">Collected by Women's Health Network</p></div>`;  
          }
  
          return tpl;
  
      },

        
        initModals : function()
        {
            var t = this;
            $(".trigger-modal").click(function(e){
                e.preventDefault();
                t.closeModal();
                sessionStorage.setItem('redirectCart', 'Y');
                var current = $(this);
                var modal = $(current.attr("data-modal-id"));
                modal.addClass("active");
            });

            $(".cart-modal .overlay, .cart-modal .close-modal").click(function(e){
                e.preventDefault();
                t.closeModal();
            });

            $(document).keyup(function(e) {
                if (e.key === "Escape") {
                    t.closeModal();
               }
           });


        },


        closeModal: function(){
            sessionStorage.removeItem('redirectCart');
            $(".cart-modal.active").removeClass("active");
        },


        showMinicart: function(){
            $("#minicart").addClass('active');
            $("#minicart_blur").fadeIn(500);
        },

        hideMinicart: function(){
            $("#minicart").removeClass('active');
            $("#minicart_blur").fadeOut(500);
        },


        minicartUpdateQty: function(qty, varient_id, item_line){

            $("#minicart").addClass("loading");

            // $.post('/cart/change.js', { quantity: qty, id: varient_id }, function(cartRes){
            $.post('/cart/change.js', { quantity: qty, line: item_line }, function(cartRes){
                $("#minicart").removeClass("loading");
                var cart = JSON.parse(cartRes);
                var item_count = parseInt(cart.item_count);
                $(".site-header-cart--count").attr("data-header-cart-count", item_count).toggleClass("visible", (item_count > 0));

                var cart_total = Shopify.formatMoney(cart.items_subtotal_price);

                $("#minicart .cart-subtotal .money").text(cart_total);

                if(item_count > 0) {
                    $("#minicart").removeClass('empty');
                    $("#minicart .cart-total, #minicart .minicart-footer").show();
                    $("#minicart .cart-items-col .minicart-title").remove();
                    $("#minicart  .minicart-title.main").show();
                    $("#minicart .minicart-empty-footer").hide();
                    cart.items.forEach(function(item, index) {
                        var line_total = Shopify.formatMoney(item.final_line_price);
                        $(`#minicart  [data-cartitem-id="${item.id}"]`).find(".cart-item--total .money").text(line_total);
                    });
                }else{
                    $("#minicart").addClass('empty');
                    $(".cart-items-col").html(`<h2 class="minicart-title">Your cart is empty</h2>`);
                    $(".cart-total, .minicart-footer").hide();
                    $("#minicart  .minicart-title.main").hide();
                    $("#minicart .minicart-empty-footer").show();

                }

                $(document).trigger("dgtlz_cart_updated", cart);


            });

        },


        minicartUpdateLineNumbers: function()
        {
            var items = $("#minicart .inner .cart-item");
            items.each(function(index, item){
                var elem = $(this);
                elem.attr("data-cartitem-line", (index + 1));
            });
        },


        initHamburgerMenu: function()
        {
            var t = this;
            // $(".hamburger").click(function () {
            //     var menu_item = $($(this).attr("data-menu-item"));
                
            //     if(menu_item.hasClass('active')){
            //         t.closeMobileMenu();
            //     }else{
            //         t.openMobileMenu();
            //     }
            // });

            $(".hamburger").click(function () {
                var current = $(this);
                current.stop().toggleClass("is-active");
                $(current.attr("data-menu-item")).stop().toggleClass('active');
                $("body").toggleClass("menu-opened");
            });
       
       
            $(".mobile-menu .menu-item .parent").on("click", function(e) {
               e.preventDefault();
               $(this).parent().find(".sub-items").addClass("active");
            });
       
            $(".mobile-menu .menu-heading .back-btn").on("click", function(e) {
               e.preventDefault();
               $($(this).attr("data-parent")).removeClass("active");
            });
       
       
            $(".mobile-menu-overlay").on("click", function(e) {
               e.preventDefault();
               $(".hamburger").removeClass("is-active");
               $("body").removeClass("menu-opened");
               $(".sub-items").removeClass("active");
               $(".menu-wrapper.active").removeClass("active");
            });
    
        },

        // openMobileMenu: function(){
        //     $(".open-search-box").removeClass("opened");
        //     $(".hamburger").addClass('is-active');
        //     var menu_height = $(window).height() - $("#top_menu").outerHeight();
        //     $(".mobile-menu-wrapper").stop().addClass('active').css({
        //         'height' : menu_height,
        //         'top' : $("#top_menu").outerHeight()
        //     });
        //     $("body").addClass("menu-opened");
        // },


        // closeMobileMenu: function(){
        //     $(".open-search-box").removeClass("opened");
        //     $(".hamburger").removeClass('is-active');
        //     $(".mobile-menu-wrapper").stop().removeClass('active').css("height", 0);
        //     $("body").removeClass("menu-opened");
            
        //     //TODO! Test if active classes are currect
        //     $(".mobile-menu-wrapper .menu-item-has-children.active .sub-items.active").removeClass("active").slideUp();
        //     $(".mobile-menu-wrapper .menu-item-has-children.active").removeClass("active");
        //     //end TODO!

        // },




        initSlickGalleries: function()
        {

            var t = this;

            if($(".slick-wrapper").length){
                

                $(".slick-wrapper").each(function(){

                    var current = $(this);


                    var slick_obj = { 
                        rtl: false,
                        arrows: true, 
                        dots: true,
                        nextArrow: '<div class="arrow-right"><img src="//cdn.shopify.com/s/files/1/0073/0903/3545/t/89/assets/arrow-right.png?v=51668538705480468051685341937" alt="" class="ml-2" /></div>',
                        prevArrow: '<div class="arrow-left"><img src="//cdn.shopify.com/s/files/1/0073/0903/3545/t/89/assets/arrow-left.png?v=58897686156853527091685341937" alt="" /></div>',
                        lazyLoad: false,
                        infinite: true,
                        slide : ".slick-item",
                        speed: 1200,
                        autoplay: true,
                        autoplaySpeed: 4000, 
                        pauseOnHover: true,
                        slidesToShow :1,
                        // slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]
                    };

                    if(current.hasClass("mobile-only")) {
                        slick_obj.arrows = false;
                        slick_obj.dots = false;
                        slick_obj.mobileFirst = true;
                        slick_obj.responsive = [
                            {
                                breakpoint: 991,
                                settings: 'unslick'
                            }
                        ];
                    }


                    var is_ap = current.attr("data-is-autoplay");
                    if(!is_ap){
                        var speed = parseInt(current.attr("data-autoplay-speed")) || 4000;
                        slick_obj.autoplaySpeed = speed;
                        slick_obj.autoplay = false;
                    }
 
                    if(current.hasClass("reviews-row") && window.matchMedia('screen and (max-width:991px)').matches) { 
                        slick_obj.swipeToSlide = true; 
                        current.on("setPosition", function(event, slick) {
                            slick.$slides.find(".inner").css('height', slick.$slideTrack.height() + 'px');
                        });
                    }else{
                      slick_obj.slidesToScroll = 1;
                    }
        
                    current.slick(slick_obj);


                });

            }

        },


        handleSubscription: function() {

            $(".newsletter-form").on("submit", function(e){

                var form = $(this);
                e.preventDefault();
                var has_error = false;
                var name_elem = form.find($("input.name"));
                var email_elem = form.find($("input.email"));
                // var email_elem = $("#footer_email_field");
                var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
                if(name_elem.val() === '') {
                    has_error = true;
                    name_elem.parent().find(".error-msg").text("Please enter you name");   
                }else{
                    name_elem.parent().find(".error-msg").text("");
                }
        
                if(email_elem.val() === '') {
                    has_error = true;
                    email_elem.parent().find(".error-msg").text("Please enter you email address");   
                }else if(!emailPattern.test(email_elem.val())){
                    has_error = true;
                    email_elem.parent().find(".error-msg").text("Inalid email address");   
                }else{
                    email_elem.parent().find(".error-msg").text("");   
                }
        
        
                if(!has_error){
        
                    form.addClass("loading");
                    form.find(".submit-btn").attr("disabled", true);

                    var timestamp = window.whn_timestamp;
                    var token = window.whn_token;
                    var service_url = 'https://whndev.wpengine.com/wp-json/service/v1/newsletter-subscription';

                    $.ajax({
                        type: 'POST', 
                        url : service_url,
                        headers: {'Authorization' : `Bearer ${token}`},
                        data: {
                            email: email_elem.val(),
                            name: name_elem.val(),
                            timestamp: timestamp
                        },
                        success: function(response){
                            form.removeClass("loading");
                            form.find(".submit-btn").attr("disabled", false);
            
                            if(response.code && response.code === 200) {
                                form.find(".gloabl-msg").text("Thank you, You signed up successfully.");
                                form.find(".form-field").val("");
                            }else{
                                form.find(".gloabl-msg").text(response.msg);
                            }
                        },
                        error: function(res){
                            form.removeClass("loading");
                            form.find(".submit-btn").attr("disabled", false);
                            form.find(".gloabl-msg").text('Something went wrong, please try again');
                        }

                    });
        
        
                }
        
                return false;
        
        
            });
        },


        buildMinicartItem: function (item, line) 
        {
            var t = this;
            var new_url = $(".product-main").attr("data-product-url");

            var selling_plan = item.selling_plan_allocation ? true : false;
            line = line + 1;
            var tpl = '';
            tpl += `<article class="cart-item" data-cartitem data-cartitem-line="${line}" data-cartitem-id="${item.id}" data-cartitem-price="${item.price}" data-is-selling-plan="${selling_plan}">`;
                tpl += `<figure class="cart-item--image-wrapper">`;
                    tpl += `<a href="${new_url}"><img src="${item.image}" /></a>`;
                tpl += `</figure>`;

                tpl += `<div class="cart-item--inner">`;

                    tpl += `<div class="cart-item--content">`;
                        tpl += `<h2 class="cart-item--content-title"><a href="${new_url}">${item.product_title} ${selling_plan ? 'Subscribe & Save' : ''}</a></h2>`;

                        tpl += `<div class="cart-item--content-price">`;
                            tpl += `<span class="money">${Shopify.formatMoney(item.price)}</span>`;
                        tpl += `</div>`;

                    tpl += `</div>`; // .cart-item--content

                    tpl += `<div class="cart-item--info">`;

                        tpl += `<div class="cart-item--quantity form-fields--qty" data-quantity-wrapper>`;

                        var css_class = t.minicartShowShowQty(item) ? 'show' : 'hide';

                            tpl += `
                                <div class="qty-widget ${css_class}">

                                    <div class="inner">
                                
                                        <div class="btn-wrap minus">
                                            <button class="trigger-qty decrease" aria-label="Decrease quantity">
                                                <i class="minus-icon" style="vertical-align: -0.2rem; box-sizing: content-box;"></i>
                                            </button>
                                        </div>
                                
                                        <div class="qty-num" aria-label="Current Qunatity" data-cartitem-quantity-text>${item.quantity}</div>
                                        
                                        <div class="btn-wrap plus">
                                            <button class="trigger-qty increase" aria-label="Increase quantity">
                                                <i class="plus-icon" style="vertical-align: -0.2rem; box-sizing: content-box;"></i>
                                            </button>
                                
                                        </div>
                                
                                    </div>
                            
                                </div>
                            `;
                        // }

                            tpl += `<div class="form-field form-field--qty-input hidden"><input class="form-field-input form-field-number form-field-filled" value="${item.quantity}" name="updates[]" type="text" pattern="\d*" tabindex="-1" aria-label="Quantity" data-quantity-input data-cartitem-quantity><label class="form-field-title">Quantity</label></div>`;

                        tpl += `</div>`; // .cart-item--quantity

                        tpl += `<div class="cart-item--remove"><a class="cart-item--remove-link">REMOVE</a></div>`;

                    tpl += `</div>`; // .cart-item--info
                    

                tpl += `</div>`; // .cart-item--inner


            tpl += `</article>`;

            return tpl;

        },



        minicartShowShowQty: function(item)
        {
            return (item.quantity > 1 || (!item.properties || (item.properties && !item.properties.shipping_interval_unit_type)));
        },



        mimicartToggleQtyDisplay: function(item)
        {
            var t = this;
            if(t.minicartShowShowQty(item)) {
                $(`#minicart .cart-item[data-cartitem-id='${item.id}'] .qty-widget`).removeClass("hide").addClass("show");
            }else{
                $(`#minicart .cart-item[data-cartitem-id='${item.id}'] .qty-widget`).addClass("hide").removeClass("show");
            }
        },



        initFloatingCheckout: function ()  
        {
            $("#trigger_checkout").click(function(){
                $("#checkout_main_submit").trigger("click");
            });
        },



        initFloatingATC: function()
        {
            
            var t = this;

            $("#floating_atc_btn").click(function(){
                $(".product-form--atc-button").trigger("click");
            });
            $("body").css("padding-bottom", $("#floating_add_to_cart").outerHeight());

            
            if(window.matchMedia("(max-width: 991px)").matches) {

                $(document).scroll(function() {
                    var top_of_element = $(".product-form--atc").offset().top;
                    var bottom_of_element = $(".product-form--atc").offset().top + $(".product-form--atc").outerHeight();
                    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
                    var top_of_screen = $(window).scrollTop();
    
                    if ((bottom_of_screen > top_of_element) && (top_of_screen > bottom_of_element - 180)){
                        $("#floating_add_to_cart").stop().slideDown();
                    }else{
                        $("#floating_add_to_cart").stop().slideUp();
                        
                        
                    }
                });

            }

            /*
            if($("#prod_var_id").length) {
                t.atcVariation(); //variant product
            }else{
                 t.atcSimple(); //simple product
            }

            */

        },



        atcVariation: function ()
        {

            $("#floating_atc_select").on("change", function(){
                var elemVal = $(this).val();
                var selectedVariant = $("#prod_var_id option:selected");
                if(elemVal == 0) {
                    selectedVariant.attr("value", selectedVariant.attr("data-single-id"));
                    $("#prod_var_id").val(selectedVariant.attr("data-single-id"));
                    $(".purchase-type-input").val("onetime");
                }else{
                    selectedVariant.attr("value", selectedVariant.attr("data-sub-id"));
                    $("#prod_var_id").val(selectedVariant.attr("data-sub-id"));
                    $(".purchase-type-input").val("autodeliver");
                }

            });


            $("#prod_var_id").on("change", function(){
                var elemVal = $("#floating_atc_select").val();
                var selectedVariant = $("#prod_var_id option:selected");
                if(elemVal == 0) {
                    selectedVariant.attr("value", selectedVariant.attr("data-single-id"))
                    $("#prod_var_id").val(selectedVariant.attr("data-single-id"));
                    $(".purchase-type-input").val("onetime");
                }else{
                    selectedVariant.attr("value", selectedVariant.attr("data-sub-id"))
                    $("#prod_var_id").val(selectedVariant.attr("data-sub-id"));
                    $(".purchase-type-input").val("autodeliver");
                }
            });
            
        },




        atcSimple: function ()
        {

            $("#floating_atc_select").on("change", function(){
                var elemVal = $(this).val();
                if(elemVal === 0) {
                    $(".id-input.default-id").attr("name", "id");
                    $(".id-input.subscribe-id").attr("name", "");
                    $(".purchase-type-input").val("onetime");
                }else{
                    $(".id-input.default-id").attr("name", "");
                    $(".id-input.subscribe-id").attr("name", "id");
                    $(".purchase-type-input").val("autodeliver");
                }

            });
            
        },


        toggleBwpBtn: function()
        {
          var urlParams = new URLSearchParams(window.location.search); 
          var should_show = urlParams.get('bwp');
          if(should_show !== null) {
            var tpl = `<script defer src='https://code.buywithprime.amazon.com/default.variant.selector.shopify.js'></script>
                        <script async fetchpriority='high' src='https://code.buywithprime.amazon.com/bwp.v1.js'></script>`;
            $(tpl).insertBefore("#amzn-buy-now");
          }
        }


    };


    App.init();





$(window).on("load", function(){

	if(window.location.href.indexOf("tools/recurring/portal/") > -1){
      //recharge portal
      	$("main").css('padding-top', $("#shopify-section-static-header-new").outerHeight() + 60);

    }
  
  
});

})(jQuery);